import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="android" task="access" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "java"
    }}>{`Java`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`CacheService cacheService = ServiceProvider.getInstance().getCacheService();
`}</code></pre>
    <Variant platform="ios" task="access" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`private var cacheService: Caching { return ServiceProvider.shared.cacheService }
`}</code></pre>
    <Variant platform="android" task="override" repeat="7" mdxType="Variant" />
    <h4 {...{
      "id": "java-1"
    }}>{`Java`}</h4>
    <p>{`First, implement a class that conforms to the `}<inlineCode parentName="p">{`Logging`}</inlineCode>{` interface. Below is an example of a logging service that only prints out messages with a log level of Error.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`class ErrorLogger implements Logging {
 @Override
 public void trace(String tag, String message) {}

 @Override
 public void debug(String tag, String message) {}

 @Override
 public void warning(String tag, String message) {}

 @Override
 public void error(String tag, String message) {
  Log.e("ErrorLogger", message);
 }
}
`}</code></pre>
    <p>{`Next, use the `}<inlineCode parentName="p">{`setLoggingService`}</inlineCode>{` API of `}<inlineCode parentName="p">{`ServiceProvider`}</inlineCode>{` to update the logging service used by the SDK.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`ServiceProvider.getInstance().setLoggingService(new ErrorLogger());
`}</code></pre>
    <p>{`To revert to the default implementation of the `}<inlineCode parentName="p">{`LoggingService`}</inlineCode>{`, you can set the logging service to nil using `}<inlineCode parentName="p">{`setLoggingService`}</inlineCode>{` API.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`ServiceProvider.getInstance().setLoggingService(null);
`}</code></pre>
    <Variant platform="ios" task="override" repeat="7" mdxType="Variant" />
    <h4 {...{
      "id": "swift-1"
    }}>{`Swift`}</h4>
    <p>{`First, implement a type that conforms to the Logging protocol, as defined above.  Below is an example of a logging service that only prints out messages with a log level of `}<inlineCode parentName="p">{`Error`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`class ErrorLogger: Logging {
  func log(level: LogLevel, label: String, message: String) {
    guard level == .error else { return }
    print("\\(label): \\(message)")
  }
}
`}</code></pre>
    <p>{`Next, set the `}<inlineCode parentName="p">{`loggingService`}</inlineCode>{` on the shared `}<inlineCode parentName="p">{`ServiceProvider`}</inlineCode>{` used by the SDK.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`ServiceProvider.shared.loggingService = ErrorLogger()
`}</code></pre>
    <p>{`To revert to the default implementation of the `}<inlineCode parentName="p">{`LoggingService`}</inlineCode>{`, you can set the loggingService to nil.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`ServiceProvider.shared.loggingService = nil
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      